import { CSSProperties, ReactNode } from 'react'

import { mainColors, semanticColors } from '../../styles/colors'

export interface PillColorsProps {
  backgroundColor: string
  color: string
}

export interface PillProps extends PillContainerProps {
  children: ReactNode
  dataCy?: string
  styles?: CSSProperties
}

export interface PillContainerProps {
  pillColor: PillColorsProps
  className?: string
  interactive?: boolean
  onClick?: () => void
}

export const PillColors: Record<string, PillColorsProps> = {
  primary: {
    backgroundColor: mainColors.primaryMedium,
    color: mainColors.white,
  },
  accent: {
    backgroundColor: mainColors.accentMedium,
    color: mainColors.white,
  },
  success: {
    backgroundColor: semanticColors.successMedium,
    color: mainColors.white,
  },
  failure: {
    backgroundColor: semanticColors.failureMedium,
    color: mainColors.white,
  },
  warning: {
    backgroundColor: semanticColors.warningMedium,
    color: mainColors.white,
  },
  neutral: {
    backgroundColor: mainColors.neutralExtraDark,
    color: mainColors.white,
  },
}
